<template>
  <div>
    <div class="bg">
      <div class="box">
        <div class="router_box">
          <div class="left">
            <img src="../../assets/stylus/image/logo_2.png" />
            <div class="router_home" @click="menu_router('/edit_home')">
              首页
            </div>
            <div class="router_homes" @click="menu_router('/contest')">
              赛事
            </div>
          </div>
          <div class="right">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img src="../../assets/stylus/image/head.png" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="我的项目">我的项目</el-dropdown-item>
                <el-dropdown-item command="logoOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="ul_box">
      <ul class="ul_as">
        <li
          @click="activeStyleClick(0)"
          :class="activeStyle == 0 ? 'activeLi' : ''"
        >
          创意编程项目
        </li>
        <li
          @click="activeStyleClick(1)"
          :class="activeStyle == 1 ? 'activeLi' : ''"
        >
          智能设计项目
        </li>
        <li
          @click="activeStyleClick(2)"
          :class="activeStyle == 2 ? 'activeLi' : ''"
        >
          编程作品列表
        </li>
        <li
          @click="activeStyleClick(3)"
          :class="activeStyle == 3 ? 'activeLi' : ''"
        >
          学习资源
        </li>
        <li
          @click="activeStyleClick(4)"
          :class="activeStyle == 4 ? 'activeLi' : ''"
        >
          人气之星排行
        </li>
      </ul>

      <div class="li_0" v-if="activeStyle == 0">
        <img src="../../assets/stylus/image/mr3.png" />
      </div>

      <div class="li_0" v-if="activeStyle == 1">
        智能设计项目
      </div>

      <div class="li_0 works" v-if="activeStyle == 2">
        <div class="list_box">
          <ul>
            <li>
              <div style="height:84%;overflow:hidden;">
                <img src="../../assets/stylus/image/default.jpg" />
              </div>
              <div class="title">我是标题</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="li_0" v-if="activeStyle == 3">
        学习资源
      </div>

      <div class="li_0 ranking" v-if="activeStyle == 4">
        <h3>/ 人气排行榜 /</h3>
        <ul>
          <li>
            <div class="type">查看作品 -></div>
            <img class="icon" src="../../assets/stylus/image/one_icon.png" />
            <img class="head" src="../../assets/stylus/image/head.png" />
            <div class="title">
              <p>小小消防员灭火作品</p>
              <p style="font-size:12px;font-weight:inherit;">
                xdn小小的梦想
              </p>
            </div>

            <div class="right">
              <span style="font-weight:bold;">1000+ </span>
              <span style="font-size:12px"> 人已点赞</span>
            </div>
          </li>

          <li>
            <div class="type">查看作品 -></div>
            <img class="icon" src="../../assets/stylus/image/one_icon.png" />
            <img class="head" src="../../assets/stylus/image/head.png" />
            <div class="title">
              <p>小小消防员灭火作品</p>
              <p style="font-size:12px;font-weight:inherit;">
                xdn小小的梦想
              </p>
            </div>

            <div class="right">
              <span style="font-weight:bold;">1000+ </span>
              <span style="font-size:12px"> 人已点赞</span>
            </div>
          </li>

          <li>
            <div class="type">查看作品 -></div>
            <img class="icon" src="../../assets/stylus/image/one_icon.png" />
            <img class="head" src="../../assets/stylus/image/head.png" />
            <div class="title">
              <p>小小消防员灭火作品</p>
              <p style="font-size:12px;font-weight:inherit;">
                xdn小小的梦想
              </p>
            </div>

            <div class="right">
              <span style="font-weight:bold;">1000+ </span>
              <span style="font-size:12px"> 人已点赞</span>
            </div>
          </li>

          <li>
            <div class="type">查看作品 -></div>
            <span class="icon_text">04</span>
            <img class="head" src="../../assets/stylus/image/head.png" />
            <div class="title">
              <p>小小消防员灭火作品</p>
              <p style="font-size:12px;font-weight:inherit;">
                xdn小小的梦想
              </p>
            </div>

            <div class="right">
              <span style="font-weight:bold;">1000+ </span>
              <span style="font-size:12px"> 人已点赞</span>
            </div>
          </li>
        </ul>
      </div>
      <div style="height:50px;"></div>
      <fotter></fotter>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../store";
import { logonOut } from "@/api/login.js";
import fotter from "../components/fotter.vue";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    fotter,
  },
  data() {
    return {
      scratch_list: [],
      tag: "",
      activeStyle: 0,
    };
  },

  created() {
    console.log(this.$route.query.type);
    if (this.$route.query.type) {
      this.activeStyle = 4;
    }
  },

  methods: {
    my_project() {
      this.$router.push({ path: "/my_works" });
    },

    start_writing() {
      var url = "/scratch/?stageArea=false";
      window.open(url);
    },

    menu_router(item) {
      this.$router.push({ path: item });
    },

    handleCommand(item) {
      if (item == "我的项目") {
        this.$router.push({ path: "/my_works" });
      } else {
        logonOut().then(() => {
          this.$router.push({ path: "/" });
          window.sessionStorage.clear();
          store.dispatch("user/userInfo", {});
        });
      }
    },

    to_router() {
      this.$router.push({ path: "/contest_details" });
    },

    activeStyleClick(type) {
      this.activeStyle = type;
    },
  },
};
</script>

<style lang="stylus" scoped>
.bg {
    height:570px;
    background-image: url(../../assets/stylus/image/mr2.png);
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: 1920px 570px;
    width:100%;

  .box {
     width:86%;
     padding:12px;
     margin:0 auto;

     .router_box {
       width:100%;
       display:flex;
       justify-content:space-between;

       .left {
          width:26%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width:130px;
            margin-right:30px;
          }

          .router_home {
              color: white;
              font-size:14px;
              cursor: pointer;
              padding: 10px 20px;
          }

          .router_homes {
              color: white;
              font-size:14px;
              cursor: pointer;
              background: #2a53cf;
              border-radius: 20px;
              padding: 10px 20px;
          }

          .router_home:hover {
            padding: 10px 20px;
            background: #2a53cf;
            border-radius: 20px;
          }
       }

       .right {
          img {
            width:30px;
          }
          img:hover {
              cursor: pointer;
          }
       }
     }
  }
}

.el-dropdown {
    position: relative;
    top:50%;
    transform:translateY(-50%);
}

.ul_box {
    background:#f2f7fc;
}

.ul_as {
     width:86%;
     padding:12px;
     margin:20px auto;
     display:flex;
     justify-content:space-between;
     color: rgb(102, 102, 102);

     li {
    display: inline-block;
    font-size:20px;
    height: 40px;
    border-radius: 100px;
    cursor: pointer;
    line-height: 40px;
    padding-left: 24px;
    padding-right: 24px;
     }

     .activeLi {
         background:#1868ff;
         color:#fff;
     }

     li:hover {
         background:#1868ff;
         color:#fff;
     }
}

.li_0 {
    background: #fff;
    width:86%;
    margin:0px auto;
    img {
      width:100%;
    }
}

.ranking {
  padding:26px;
  h3 {
    text-align:center;
    color:#1868ff;
    font-size:30px;
    font-weight:border ;
  }

  ul {
    width:60%;
    margin:50px auto;

    li {
        height:100px;
        width:100%;
        cursor: pointer;
        position: relative;
        border-radius: 55px;
        margin-bottom: 20px;
        overflow: hidden;
        position:relative;
        background:#f2f7fd;
        color:#333;

        .type {
          position:absolute;
          left:50%;
          top:50%;
          transform:translate(-50% , -50%);
          font-size:20px;
          display:none;
        }

      .icon {
        width: 40px;
        height:50px;
        position:absolute;
        left:7%;
        top:50%;
        transform:translateY(-50%);
      }
      .icon_text {
        position:absolute;
        left:8%;
        top:50%;
        transform:translateY(-50%);
        font-size:20px;
      }
      .head {
        width: 95px;
        height:70px;
        position:absolute;
        left:17%;
        top:50%;
        transform:translateY(-50%);
        background:#eee;
      }
      .title {
        position:absolute;
        left:32%;
        top:50%;
        transform:translateY(-50%);
        p {
          padding:6px;
          font-size:18px;
          font-weight:bold;
        }
      }

      .right {
        position:absolute;
        right:8%;
        top:50%;
        transform:translateY(-50%);
        font-size:28px;
      }
    }

    li:nth-child(1){
        background-image: linear-gradient(-269deg, #ffab7e 0%, #f23e8c 100%);
        color:white;
    }

    li:nth-child(2){
        background-image: linear-gradient(90deg, #3dc3ff 0%, #4271f2 100%);
        color:white;
    }

    li:nth-child(3){
        background-image: linear-gradient(89deg, #ca6bfd 0%, #605bd6 99%);
        color:white;
    }

    li:hover {
      background:#1868ff;
      color:#1868ff;
      font-size:12px;

      .type {
        display:inline-block;
        color:white;
        font-size:26px;
        z-index:2;
      }

      img {
        display:none;
      }
    }
  }
}

.works {
  padding-top:20px;
  padding-left:20px;
}

  .list_box {
    width:100%;
    ul {
      width:100%;
      margin:0 auto;
      display:flex;
      justify-content:space-between;
      flex-wrap:wrap;
      padding-bottom:30px;
      li {
        width:18.8%;
        height:280px;
        background:#fff;
        border-radius:6px;
        overflow:hidden;
        position:relative;
        cursor: pointer;
        margin-bottom:1.4%;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        img {
          height:100%;
        }
        img:hover {
          height:105%;
          transition:all 0.5s;
        }
        .title {
          position:absolute;
          bottom:0;
          width:100%;
          text-align:center;
          padding:16px 0;
        }
      }

      li:hover {
        color: #409EFF;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transition:all 0.5s;
      }
    }
  }
</style>
